{
    "name": "@usereactify/search-internals",
    "version": "1.0.0",
    "description": "A Forked React UI components library for building search experiences",
    "main": "lib/index.js",
    "types": "lib/index.d.ts",
    "module": "lib/index.es.js",
    "js:next": "lib/index.es.js",
    "private": false,
    "sideEffects": false,
    "files": [
        "lib/",
        "umd"
    ],
    "scripts": {
        "watch": "yarn build:commonjs -w && yarn build:es -w",
        "build": "yarn build:commonjs && yarn build:es && yarn build:copy-types",
        "build:commonjs": "cross-env BABEL_ENV=commonjs babel --ignore __tests__ src --out-dir lib",
        "build:es": "cross-env BABEL_ENV=es babel src/index.js --out-file lib/index.es.js",
        "build:copy-types": "npx babel-node ./scripts/copy-types.js",
        "build:umd": "cross-env BABEL_ENV=commonjs webpack --progress -p --config webpack.config.umd.js",
        "stats": "webpack --progress -p --config webpack.config.umd.js --json > stats.json",
        "version-upgrade": "nps upgrade -c ../../package-scripts.js",
        "prepublishOnly": "yarn run build",
        "postpublish": "yarn run version-upgrade",
        "test": "jest",
        "clear-cache-test": "jest --clearCache",
        "typescript": "tsc -p tsconfig.json"
    },
    "jest": {
        "rootDir": "src",
        "testURL": "http://localhost/"
    },
    "repository": {
        "type": "git",
        "url": "https://github.com/appbaseio/reactivesearch.git"
    },
    "author": "metagrover",
    "license": "Apache-2.0",
    "dependencies": {
        "@appbaseio/analytics": "^1.1.1",
        "@appbaseio/reactivecore": "9.15.2",
        "@appbaseio/rheostat": "^1.0.0-alpha.15",
        "@emotion/core": "^10.0.28",
        "@emotion/styled": "^10.0.27",
        "appbase-js": "^5.3.4",
        "cross-env": "^5.2.0",
        "dayjs": "^1.11.7",
        "downshift": "^1.31.2",
        "echarts": "^5.3.3",
        "echarts-for-react": "^3.0.2",
        "emotion-theming": "^10.0.27",
        "hoist-non-react-statics": "^3.2.1",
        "hotkeys-js": "^3.8.7",
        "polished": "^1.9.3",
        "prop-types": "^15.6.0",
        "react-day-picker": "^7.0.5",
        "react-redux": "^6.0.1",
        "url-search-params-polyfill": "^7.0.0",
        "xss": "^1.0.11"
    },
    "peerDependencies": {
        "react": ">=15",
        "react-dom": ">=15"
    },
    "devDependencies": {
        "@emotion/jest": "11.7.1",
        "@types/react": "^16.3.8",
        "babel-cli": "^6.26.0",
        "babel-core": "^6.26.0",
        "babel-jest": "^22.4.4",
        "babel-loader": "^7.1.2",
        "babel-plugin-emotion": "^10.0.33",
        "babel-plugin-transform-class-properties": "^6.24.1",
        "babel-plugin-transform-object-rest-spread": "^6.26.0",
        "babel-preset-env": "^1.6.1",
        "babel-preset-react": "^6.24.1",
        "babili-webpack-plugin": "^0.1.2",
        "brotli-webpack-plugin": "^0.5.0",
        "compression-webpack-plugin": "^1.0.1",
        "eslint-plugin-jest": "^21.12.2",
        "fs-extra": "^7.0.0",
        "glob": "^7.1.2",
        "jest": "^22.4.2",
        "nps": "^5.9.5",
        "path": "^0.12.7",
        "react": "^18.0.2",
        "react-dom": "^18.0.2",
        "react-test-renderer": "^18.2.0",
        "tslint": "^5.9.1",
        "typescript": "^2.8.1",
        "webpack": "^4.18.0"
    },
    "resolutions": {
        "@types/react": "16.3.7"
    }
}